'use client';

import { TypographyCaption } from '@heidi/design-system/typography';
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import { useIntl } from 'react-intl';
import { createTemplateMessages } from '../create-template/createTemplate.messages';
import type { LoaderPhase } from './types';

interface StatusTextProps {
  phase: LoaderPhase;
  context?: string;
}

export function StatusText({ phase }: StatusTextProps) {
  const intl = useIntl();

  const getStatusText = (): string => {
    switch (phase) {
      case 'understanding':
        return intl.formatMessage(
          createTemplateMessages.assemblyLoaderUnderstandingRequest
        );
      case 'building':
        return intl.formatMessage(createTemplateMessages.assemblyLoaderBuildingStructure);
      case 'drafting':
        return intl.formatMessage(createTemplateMessages.assemblyLoaderDraftingExample);
      case 'complete':
        return intl.formatMessage(createTemplateMessages.assemblyLoaderComplete);
      default:
        return intl.formatMessage(
          createTemplateMessages.assemblyLoaderUnderstandingRequest
        );
    }
  };

  // Remove trailing ellipsis from translation if present
  const statusText = getStatusText()
    .replace(/…$/, '')
    .replace(/\.\.\.$/, '');

  return (
    <div className="flex h-8 items-center justify-center">
      <AnimatePresence mode="wait">
        <m.div
          key={phase}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{
            duration: 0.4, // More readable transition
            ease: [0.23, 1, 0.32, 1], // ease-out-quint
          }}
        >
          <TypographyCaption className="text-center text-text-secondary">
            {statusText}
          </TypographyCaption>
        </m.div>
      </AnimatePresence>
    </div>
  );
}
